module.exports = __webpack_public_path__ + "img/swaziland.54b34b5c.png";